import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-1.5 pb-1.5 pt-2 text-center font-catering-body" }
const _hoisted_2 = { class: "mx-auto grid h-16 w-16 place-items-center rounded-full bg-catering-lemon shadow-catering-accent" }
const _hoisted_3 = { class: "mb-0 mt-3.5 font-catering-display text-2xl text-catering-ink-900" }
const _hoisted_4 = { class: "mx-auto mb-4 mt-2.5 max-w-[34ch] text-sm leading-relaxed text-catering-ink-600" }

import { CheckIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'

import Pill from '@/components/catering/Pill.vue'


export default {
  __name: 'SetupReviewPanel',
  props: {
  underReview: { type: Boolean, default: false }
},
  emits: ['steps'],
  setup(__props) {

const COPY = {
  review: {
    heading: 'Your setup is done.',
    body: 'Every step on your list is finished. We check over every new store by hand, so someone at Bottle is going through yours and will be in touch. Nothing here is waiting on you.'
  },
  reviewed: {
    heading: 'You are all set.',
    body: 'Nothing else is waiting on you. Close this panel and your dashboard is right where you left it.'
  }
}

// The drawer owns this answer and hands it down. Working it out again here from
// anything else is how the heading and the header directly above it end up
// telling the merchant two different stories in the same beat.
const props = __props


const copy = computed(() => (props.underReview ? COPY.review : COPY.reviewed))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(CheckIcon), {
        class: "h-8 w-8 text-catering-ink-900",
        "aria-hidden": "true"
      })
    ]),
    _createElementVNode("h3", _hoisted_3, _toDisplayString(copy.value.heading), 1),
    (__props.underReview)
      ? (_openBlock(), _createBlock(Pill, {
          key: 0,
          tone: "warning",
          size: "sm",
          dot: "",
          class: "mt-2.5"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Pending review", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_4, _toDisplayString(copy.value.body), 1),
    _createElementVNode("button", {
      type: "button",
      class: "cursor-pointer border-none bg-transparent p-0 text-sm font-semibold text-catering-ink-500 underline underline-offset-2",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('steps')))
    }, " Look over your steps again ")
  ]))
}
}

}